import React from 'react';
import Logo from '../assets/images/Logo.png';
import {
	Container,
	Typography,
	Box,
	List,
	ListItem,
	ListItemText,
	Link,
	Grid,
} from '@mui/material';

const DeleteAccountPage = () => {
	return (
		<Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
			<Grid
				container
				flexDirection={'row'}
				alignItems={'center'}
				justifyContent={'center'}>
				<Box
					component={'img'}
					src={Logo}
					sx={{
						padding: '2px',
						backgroundColor: '#FFFFFF',
						borderRadius: '5px',
					}}
					width={300}
					height={80}
				/>
			</Grid>
			<Box sx={{ textAlign: 'center', mb: 4, mt: 4 }}>
				<Typography variant="h4" component="h1" gutterBottom>
					Delete Your Account
				</Typography>
				<Typography variant="body1" color="text.secondary">
					Follow the instructions below to delete your account
					permanently.
				</Typography>
			</Box>

			<Box sx={{ mb: 4 }}>
				<Typography variant="h6" component="h2" gutterBottom>
					Steps to Delete Your Account:
				</Typography>
				<List sx={{ pl: 2 }}>
					<ListItem>
						<ListItemText primary="1. Log in to your SenzCare.Ai account in the mobile app." />
					</ListItem>
					<ListItem>
						<ListItemText primary="2. Click on the top right corner menu and go to about screen." />
					</ListItem>
					<ListItem>
						<ListItemText primary='3. Select the "Delete Account" option and follow the on-screen instructions.' />
					</ListItem>
				</List>
			</Box>

			<Box>
				<Typography variant="h6" component="h2" gutterBottom>
					Need Assistance?
				</Typography>
				<Typography variant="body1" color="text.secondary" gutterBottom>
					If you encounter any issues during the process, please
					contact our support team. We&lsquo;re here to help!
				</Typography>
				<Typography variant="body1">
					Email us at:{' '}
					<Link to="mailto:info@senzmate.com" underline="hover">
						info@senzmate.com
					</Link>
				</Typography>
			</Box>
		</Container>
	);
};

export default DeleteAccountPage;
